import { TimeOfNightOptionsType } from './types';

export const TIME_OF_NIGHT_OPTIONS: TimeOfNightOptionsType = [
  {
    id: 'early_evening',
    title: 'Early evening (6–8 PM)',
  },
  {
    id: 'late_night',
    title: 'Late night (11 PM–1 AM)',
  },
  {
    id: 'dawn',
    title: 'Dawn (4 AM – after the party)',
  },
];
